import React, { PropsWithChildren, useMemo } from 'react';
import { MyOrgUnitAssortmentsDTO } from '@retail/auth/types';
import { flattenOrgUnitAssortments, toOrgUnitAssortments } from '@retail/mgpris/config-types';
import { useFetchMyAssortmentApi } from '@retail/auth/data-access';
import {
  MyOrgUnitAssortmentsProvider,
  MyOrgUnitAssortmentsState,
  useUserBrands,
} from '@retail/app/stores/selected-context';

const noAssortments: MyOrgUnitAssortmentsDTO = { locationAssortments: [] };

export const MyOrgUnitAssortmentsProviderImpl: React.FC<PropsWithChildren> = ({ children }) => {
  const { selectedBrand } = useUserBrands();

  const { data } = useFetchMyAssortmentApi({
    brandId: selectedBrand.brandId,
    tenantAppKey: selectedBrand.tenant.tenantAppKey,
  });

  const value: MyOrgUnitAssortmentsState = useMemo(() => {
    const assortments = toOrgUnitAssortments(data ?? noAssortments);
    return { assortments, allAssortments: flattenOrgUnitAssortments(assortments) };
  }, [data]);

  return <MyOrgUnitAssortmentsProvider value={value}>{children}</MyOrgUnitAssortmentsProvider>;
};
